import { PointStatus } from '@models/point/common';

export const PointHistoryStatusKr: Record<PointStatus, string> = {
  EARNED: '포인트 적립',
  EXPIRED: '기간 만료',
  EARN_CANCELED: '적립 취소',
  USED: '포인트 사용',
  USED_CANCELED: '사용 취소',
};
